// extracted by mini-css-extract-plugin
export var inputGroup = "base-module--inputGroup--54841";
export var inputGroupOpen = "base-module--inputGroupOpen--b151b";